export default {"src":"/_next/static/media/star-half.8fceda99.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};